import React, { FormEvent, useState } from "react";
import { ArrowRightIcon, CheckIcon, MailIcon, MapPinIcon, MessageCircleIcon, PhoneIcon, BoxIcon } from "lucide-react";
import { PageHero } from "../components/PageHero";
import { Reveal } from "../components/Reveal";
import { CONTACT } from "../data/mccContent";
import { IMAGES } from "../data/images";
type ContactMethod = {
  icon: BoxIcon;
  title: string;
  copy: string;
  href?: string;
  external?: boolean;
};
const ADDRESS = "Block 127, Plot 9, Bunmi Olowude Street, Lekki Phase 1, Lagos, Nigeria";
export function Contact() {
  const [booked, setBooked] = useState(false);
  const whatsapp = `https://wa.me/${CONTACT.whatsappNumber}?text=${encodeURIComponent("Hello MCC, I would like to arrange a campus visit.")}`;
  const methods: ContactMethod[] = [{
    icon: MapPinIcon,
    title: "Visit",
    copy: "2nd Roundabout, by Pinnacle Petrol Station, Lekki Phase 1",
    href: `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(ADDRESS)}`,
    external: true
  }, {
    icon: PhoneIcon,
    title: "Call",
    copy: "09062540705 · 07076529048",
    href: "tel:+2349062540705"
  }, {
    icon: MailIcon,
    title: "Email",
    copy: "hello@maplecc.ca · marketing@maplecc.ca",
    href: `mailto:${CONTACT.email}`
  }, {
    icon: MessageCircleIcon,
    title: "WhatsApp",
    copy: "Chat with MCC Admissions",
    href: whatsapp,
    external: true
  }];
  function book(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    setBooked(true);
    window.dispatchEvent(new CustomEvent("mcc:conversion", {
      detail: {
        eventName: "campus_visit_booking"
      }
    }));
  }
  const field = "w-full border-b border-[#aeb2b4] bg-transparent py-3 text-base text-[#061f38] outline-none placeholder:text-[#8a9196] focus:border-[#061f38]";
  return <>
      <PageHero variant="split" eyebrow="CONTACT MCC" title="Come and see Maple for yourself." description="Book a campus visit, call the office, or message Admissions directly." image={IMAGES.rooftop} imageAlt="MCC rooftop overlooking Lekki" breadcrumb="Contact" data-id="element-871" data-mp="26vcyerusv3a0" />

      <main data-id="element-872" data-mp="1h8itad0m3swb">
        <section className="mx-auto max-w-[1440px] px-5 py-20 md:px-9 md:py-28" data-id="element-873" data-mp="1h921v34dh4xo">
          <div className="grid gap-px bg-[#dedbd3] sm:grid-cols-2 lg:grid-cols-4" data-id="element-874" data-mp="1w59jpwsb5u9s">
            {methods.map(({
            icon: Icon,
            title,
            copy,
            href,
            external
          }, i) => <Reveal key={title} delay={i * 0.06} data-id="element-875" data-mp="13g2ph9zvzquc" data-mpi={i}>
                <a href={href} target={external ? "_blank" : undefined} rel={external ? "noreferrer" : undefined} className="group flex h-full min-h-[220px] flex-col justify-between bg-[#fbfaf6] p-6 transition-colors duration-200 hover:bg-[#061f38] hover:text-white" data-id="element-876" data-mp="13erhexzerwxf">
                  <Icon size={22} className="text-[#bb1e35] transition-colors duration-200 group-hover:text-[#f0b1b9]" data-id="element-877" data-mp="18f6z21qq3ql7" />
                  <div data-id="element-878" data-mp="ko9uja19bvjz">
                    <h2 className="text-2xl font-medium tracking-[-0.04em]" data-id="element-879" data-mp="frb16tpf3smu">{title}</h2>
                    <p className="mt-2 text-sm leading-6 text-[#4f5963] transition-colors duration-200 group-hover:text-white/70" data-id="element-880" data-mp="fpgq073y7evy">{copy}</p>
                  </div>
                </a>
              </Reveal>)}
          </div>
        </section>

        <section className="bg-[#f2f0eb]" data-id="element-881" data-mp="2hh8i83bn3e06">
          <div className="mx-auto grid max-w-[1440px] lg:grid-cols-2" data-id="element-882" data-mp="2hia30zigjev3">
            <Reveal className="px-5 py-20 md:px-9 md:py-28" data-id="element-883" data-mp="2mgbots79psa9">
              <p className="text-xs font-semibold tracking-[0.18em] text-[#bb1e35]" data-id="element-884" data-mp="3a5e4wvm97d2n">BOOK A VISIT</p>
              <h2 className="mt-5 text-4xl font-medium leading-[0.95] tracking-[-0.06em] md:text-5xl" data-id="element-885" data-mp="3f3z3kqluxooz">Walk the campus with us.</h2>
              {booked ? <div role="status" className="mt-10 border-l-2 border-[#c5233d] pl-5" data-id="element-886" data-mp="313od3oogmc4c">
                  <CheckIcon size={20} className="text-[#bb1e35]" data-id="element-887" data-mp="3550869q3rpjx" />
                  <p className="mt-3 text-lg" data-id="element-888" data-mp="1ppj4gidaxe2o">Request received. Admissions will call to confirm your visit.</p>
                </div> : <form onSubmit={book} className="mt-10 grid gap-6" data-id="element-889" data-mp="1tr4piqzzoyny">
                  <label className="grid gap-1 text-xs font-semibold tracking-[0.12em] text-[#4f5963]" data-id="element-890" data-mp="29y0x69u7zjr9">PARENT / GUARDIAN<input required className={field} placeholder="Your name" data-id="element-891" data-mp="257arswlsngwk" /></label>
                  <div className="grid gap-6 sm:grid-cols-2" data-id="element-892" data-mp="255hitanpkkle">
                    <label className="grid gap-1 text-xs font-semibold tracking-[0.12em] text-[#4f5963]" data-id="element-893" data-mp="208zicmzev8ev">PHONE<input required type="tel" className={field} placeholder="080…" data-id="element-894" data-mp="1va61qlotv1ah" /></label>
                    <label className="grid gap-1 text-xs font-semibold tracking-[0.12em] text-[#4f5963]" data-id="element-895" data-mp="2svtyj7p73lmj">PREFERRED DATE<input required type="date" className={field} data-id="element-896" data-mp="2nytt8z066mwh" /></label>
                  </div>
                  <label className="grid gap-1 text-xs font-semibold tracking-[0.12em] text-[#4f5963]" data-id="element-897" data-mp="2ixny6uj1enjs">STUDENT’S CURRENT GRADE<select className={`${field} bg-[#f2f0eb]`} data-id="element-898" data-mp="2ew2hey3dtp4b"><option data-id="element-899" data-mp="2ezgg9wcu7g70">Grade 9 / JSS3</option><option data-id="element-900" data-mp="17k20gkz43dmn">Grade 10 / SS1</option><option data-id="element-901" data-mp="17kbpa58f7eqr">Grade 11 / SS2</option><option data-id="element-902" data-mp="17hfswlc80y4f">Grade 12 / SS3</option><option data-id="element-903" data-mp="13i6xzd5g2u7a">Recent graduate</option></select></label>
                  <button type="submit" className="mt-2 inline-flex w-fit items-center gap-2 bg-[#c5233d] px-5 py-4 text-sm font-semibold text-white transition-colors duration-200 hover:bg-[#a71931] focus:outline-none focus-visible:ring-2 focus-visible:ring-[#bb1e35] focus-visible:ring-offset-2" data-id="element-904" data-mp="13k1nl4rnvahp">Request visit <ArrowRightIcon size={16} data-id="element-905" data-mp="3o4nq3hm16djt" /></button>
                </form>}
            </Reveal>
            <div className="relative min-h-[420px]" data-id="element-906" data-mp="3sy06j4gk3e1h">
              <iframe title="Map showing Maple Canadian College in Lekki Phase 1" src={`https://www.google.com/maps?q=${encodeURIComponent(ADDRESS)}&output=embed`} loading="lazy" className="absolute inset-0 h-full w-full border-0 grayscale" referrerPolicy="no-referrer-when-downgrade" data-id="element-907" data-mp="1r74xzhupcwf" />
            </div>
          </div>
        </section>

        <section className="mx-auto max-w-[1440px] px-5 py-20 md:px-9" data-id="element-908" data-mp="fpndlvz9xdh7">
          <Reveal className="grid gap-4 border-t border-[#061f38] pt-8 md:grid-cols-2" data-id="element-909" data-mp="2cjiffb9wo0d6">
            <p className="text-2xl font-medium tracking-[-0.04em]" data-id="element-910" data-mp="2hgqn2hxfgm06">{ADDRESS}</p>
            <p className="text-sm leading-6 text-[#4f5963] md:text-right" data-id="element-911" data-mp="3ks63k37vscfz">Near the 2nd Roundabout, by Pinnacle Petrol Station · Marwa bus-stop</p>
          </Reveal>
        </section>
      </main>
    </>;
}